import React, { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import ExportSources from 'components/common/ExportSources';
import { EventContext } from 'components/context/EventContext';

import { useModal } from 'vibo-ui/Modal';
import { MAX_EXPORT_SONGS_TO_APPLE_MUSIC } from 'services/constants';

import { Modals, MusicExportSource } from 'types/enums';
import {
  ExportEventToSourceModalProps,
  TypeExportEventSource,
} from 'components/modals/ExportEventToSourceModal';

const ExportMusicButtons: FC = () => {
  const { id: eventId = '', sectionId = '' } = useParams<keyof EventPageRouteParams>();

  const navigate = useNavigate();

  const eventContext = useContext(EventContext);

  const { openModal } = useModal();

  const openExportEventToSourceModal = (
    source: TypeExportEventSource,
    maxSongsForExport?: number
  ) =>
    !!eventContext?.event &&
    openModal<ExportEventToSourceModalProps>({
      key: Modals.exportEventToSource,
      props: {
        eventContext,
        eventId,
        sectionId,
        source,
        maxSongsForExport,
      },
    });

  const goToBeatsourcePage = () => navigate(`/event/${eventId}/beatsource`);

  return (
    <ExportSources
      spotify={{
        onClick: () => openExportEventToSourceModal(MusicExportSource.spotify),
      }}
      appleMusic={{
        onClick: () =>
          openExportEventToSourceModal(
            MusicExportSource.appleMusic,
            MAX_EXPORT_SONGS_TO_APPLE_MUSIC
          ),
      }}
      beatsource={{
        onClick: goToBeatsourcePage,
      }}
    />
  );
};

export default ExportMusicButtons;
